import { useEffect, useState } from 'react';
import { loadOrderEntryMode } from '../utils/orderEntryMode';

/**
 * This shop's staff-order payment mode ('shopify' | 'counter'), or null until
 * known. See utils/orderEntryMode.
 */
export function useOrderEntryMode() {
  const [mode, setMode] = useState(null);
  useEffect(() => {
    let cancelled = false;
    loadOrderEntryMode().then(m => { if (!cancelled) setMode(m); });
    return () => { cancelled = true; };
  }, []);
  return mode;
}

export default useOrderEntryMode;
